import React from "react";
import { apiRequest } from "../util/util";
import { updatePaymentRefund } from "../util/db";

export default function AdminPagePaymentsRefundButton({ item }) {
  const [isRefunding, setIsRefunding] = React.useState(false);
  const [removeFromEvent, setRemoveFromEvent] = React.useState(false);

  const refunded = Number(item.amount_refunded) || 0;
  const total = Number(item.amount_total) || 0;
  const isFullyRefunded = refunded >= total && total > 0;
  const canRefund = !isFullyRefunded && !isRefunding;

  async function refundPayment(id) {
    setIsRefunding(true);
    try {
      const response = await apiRequest("stripe-create-refund", "POST", {
        payment_intent: id,
        remove_from_event: removeFromEvent, // send checkbox value
        event_entries_id: item.event_entries?.[0]?.id,
      });
      const refundAmount = response.data.amount;
      await updatePaymentRefund(id, refundAmount);
    } finally {
      setIsRefunding(false);
    }
  }

  return (
    <div>
      {canRefund ? (
        <>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => refundPayment(item.payment_intent)}
          >
            Refund
          </button>
          <div style={{ marginTop: 4 }}>
            <label style={{ fontWeight: "normal" }}>
              <input
                type="checkbox"
                checked={removeFromEvent}
                onChange={(e) => setRemoveFromEvent(e.target.checked)}
                style={{ marginRight: 4 }}
              />
              Remove from event
            </label>
          </div>
        </>
      ) : isFullyRefunded ? (
        <button className="btn btn-sm btn-danger" disabled>
          Refunded
        </button>
      ) : (
        <button className="btn btn-sm btn-danger" disabled>
          Refunding
        </button>
      )}
    </div>
  );
}
